import { useQuery } from '@tanstack/react-query'
import { api } from '../../api'

export type ConditionConfidence = 'confirmed' | 'high' | 'moderate' | 'low'

export interface ConditionFlag {
  condition: string
  confidence: ConditionConfidence
  message: string
  tier?: number | null
  criteria_met?: string[]
  supporting_signals?: string[]
}

interface ConditionFlagsResponse {
  flags: ConditionFlag[]
}

export function useConditionFlags(enabled = true) {
  return useQuery({
    queryKey: ['patient', 'condition-flags'],
    queryFn: () => api.get<ConditionFlagsResponse>('/api/patient/condition-flags'),
    staleTime: 10 * 60_000,
    enabled,
  })
}
